<template>
  <div>
    <v-dialog
        v-model="dialogVisible"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
        class="d-flex flex-column"
    >
      <v-card tile class="d-flex flex-column" style="height: 100vh;">
        <div
          id="titulo-dialog"
          class="df px-4 py-3 d-flex align-center"
          style="flex-shrink: 0; position: relative; z-index: 5; background: #071a2a;"
        >
          <v-btn icon dark @click="close()" class="me-4">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <img :src="logo" alt="webcotacao" class="h-35px">
        </div>

        <!-- Breadcrumbs -->
        <div class="px-4 py-2" style="flex-shrink: 0; background: white; position: relative; z-index: 4;">
          <div class="d-flex align-center" style="font-size: 14px;">
            <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Inicio</span>
            <span class="mx-1" style="color: #9e9e9e;">></span>
            <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Cotação</span>
            <span class="mx-1" style="color: #9e9e9e;">></span>
            <app-badge color="blue">Detalhes da Cotação</app-badge>
          </div>
        </div>

        <!-- Title Row + Actions + Progress -->
        <div class="px-4 py-3" style="flex-shrink: 0; background: white; position: relative; z-index: 3; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);">
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="d-flex align-center">
              <v-btn icon @click="close()" class="mr-2">
                <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
              </v-btn>

              <h2 class="font-weight-bold mr-3 text-h6">Cotação {{ idCotacao ? `[${idCotacao}]` : '' }}</h2>
              <app-badge rounded :color="getStatusColor((cotacao && cotacao.status_nome) || null)">
                <span :class="getStatusIcon((cotacao && cotacao.status_nome) || null)" class="mr-1 text-sm-body-1"></span>
                {{ (cotacao && cotacao.status_nome) || null }}
              </app-badge>
            </div>

            <div class="d-flex align-center">
              <v-btn
                  text
                  color="error"
                  class="text-capitalize mr-2"
                  :disabled="cotacao && (cotacao.status_nome === 'Concluída' || cotacao.status_nome === 'Prazo Encerrado' || cotacao.status_nome === 'Cancelada')"
                  @click="endQuotationNow"
              >
                Encerrar agora
              </v-btn>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    color="primary"
                    class="text-capitalize mr-2"
                    :disabled="cotacao && (cotacao.status_nome === 'Concluída' || cotacao.status_nome === 'Cancelada')"
                    @click="openExtendDeadlineDialog"
                  >
                    Prorrogar vigência
                  </v-btn>
                </template>
                <span>Alterar a data de término para dar mais prazo aos fornecedores.</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    color="primary"
                    class="text-capitalize mr-2"
                    :loading="isLoading"
                    @click="baixarEvidencias"
                  >
                    Baixar Histórico
                  </v-btn>
                </template>
                <span>Baixar o histórico detalhado desta cotação para auditoria.</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    color="primary"
                    class="text-capitalize mr-2"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click="repeatQuotation"
                  >
                    Repetir cotação
                  </v-btn>
                </template>
                <span>Criar uma nova cotação copiando esta como base. Só é possível se existir pedido vinculado à cotação.</span>
              </v-tooltip>

              <v-btn
                v-if="cotacao && cotacao.status_nome === 'Rascunho'"
                color="primary"
                class="text-capitalize"
                elevation="0"
                @click="edit"
              >
                Editar cotação
              </v-btn>

              <v-btn
                v-else-if="cotacao && cotacao.status_nome === 'Concluída'"
                color="primary"
                class="text-capitalize"
                elevation="0"
                :disabled="cotacao && cotacao.situacao_pedidos_nome === 'Todos gerados'"
                @click="gerarPedidos"
              >
                Gerar pedidos
              </v-btn>

              <v-btn
                v-else
                  color="primary"
                  class="text-capitalize"
                  elevation="0"
                  :disabled="cotacao && cotacao.status_nome === 'Cancelada'"
                  @click="activeTab = 1"
              >
                Analisar propostas
              </v-btn>
            </div>
          </div>
        </div>

        <div v-if="!isLoading" id="content-body" class="flex-grow-1 overflow-y-auto lighten-5">

          <!-- Header Info -->
          <v-card outlined rounded class="mt-1 rounded-0">
            <v-card-text class="pa-4 header-info">
              <v-row class="ma-0" dense align="start">
                <v-col cols="12" md="3" class="px-0">
                  <div class="text-caption grey--text mb-1">Cotação</div>
                  <div class="text-body-2 font-weight-medium">
                    #{{ (cotacao && cotacao.cotacao_transacao_id) || '-' }} — {{ (cotacao && cotacao.cotacao_titulo) || '-' }}
                  </div>
                </v-col>

                <v-col cols="12" md="3" class="px-0">
                  <div class="text-caption grey--text mb-1">Empresa/Filial</div>
                  <div class="text-body-2 font-weight-medium">{{ (config && config.razao_social) || '-' }}</div>
                  <div class="text-caption grey--text">{{ (config && config.idfilial != null) ? 'Filial ' + config.idfilial : '-' }}</div>
                </v-col>

                <v-col cols="12" md="4" class="px-0">
                  <div class="text-caption grey--text mb-1">Período</div>
                  <div class="text-body-2">
                    Início: {{ (config && config.inicio_periodo_recebimento_proposta) || '-' }} ·
                    Término: {{ (config && config.termino_periodo_recebimento_proposta) || '-' }}
                    <span v-if="prazoInfo" :class="[prazoInfo.color, 'ml-1 font-weight-bold']">· {{ prazoInfo.text }}</span>
                  </div>
                </v-col>

                <v-col cols="12" md="2" class="px-0">
                  <div class="text-caption grey--text mb-1">Responsável</div>
                  <div class="text-body-2">
                    {{ (responsavel && responsavel.nome_completo) || '-' }}
                    <span class="grey--text text--darken-1">· {{ (seguidores && seguidores.length) || 0 }} seguidores</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Progress Steps -->
          <v-card flat class="my-1 px-4">
            <v-card-text class="px-4 py-2">
              <div class="d-flex align-center justify-space-between">
                <div v-for="(step, index) in steps" :key="index" class="d-flex align-center" :class="{ 'flex-grow-1': index < steps.length - 1 }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-flex align-center flex-shrink-0">
                        <!-- Completed State -->
                        <v-avatar v-if="step.completed" size="24" color="blue lighten-5" class="d-flex justify-center align-center" style="border: 1px solid #5dc3fd;">
                          <v-icon color="primary" x-small>mdi-check</v-icon>
                        </v-avatar>

                        <!-- Active State -->
                        <v-avatar v-else-if="step.active" size="24" color="primary" class="d-flex justify-center align-center">
                          <span class="white--text caption font-weight-bold">{{ step.number }}</span>
                        </v-avatar>

                        <!-- Pending State -->
                        <v-avatar v-else size="24" color="gray lighten-5" class="d-flex justify-center align-center" style="border: 1px solid #E0E0E0;">
                          <span class="grey--text caption font-weight-bold">{{ step.number }}</span>
                        </v-avatar>

                        <span :class="['ml-3 text-caption', (step.completed || step.active) ? 'grey--text text--darken-2' : 'grey--text']">
                          {{ step.label }}
                        </span>
                      </div>
                    </template>
                    <span>{{ step.tooltip }}</span>
                  </v-tooltip>

                  <v-divider
                    v-if="index < steps.length - 1"
                    class="mx-2"
                    style="border-width: 2px;"
                    :class="step.completed ? 'primary' : 'grey lighten-3'"
                  ></v-divider>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- Tabs -->
          <v-card flat class="mb-0 rounded-0">
            <v-tabs v-model="activeTab" background-color="white" color="primary">
              <v-tab v-for="tab in tabs" :key="tab.id" class="text-capitalize">
                <v-tooltip v-if="tab.tooltip" top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                      <span :class="tab.icon" class="mr-2 text-sm-body-1"></span> {{ tab.label }}
                    </span>
                  </template>
                  <span>{{ tab.tooltip }}</span>
                </v-tooltip>
                <span v-else class="d-inline-flex align-center">
                  <span :class="tab.icon" class="mr-2 text-sm-body-1"></span> {{ tab.label }}
                </span>
              </v-tab>
            </v-tabs>
          </v-card>

          <!-- Main Content -->
          <div class="py-1">
            <v-tabs-items v-model="activeTab" class="transparent">
              <v-tab-item key="resumo">
                <v-row>
                  <!-- Status e Diagnóstico Section -->
                  <v-col cols="12" md="8">
                    <v-card outlined height="100%">
                      <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-1">Status e diagnóstico</v-card-title>
                      <v-card-text>
                        <v-row>
                          <!-- Column 1: Statuses -->
                          <v-col cols="12" md="5">
                            <div class="mb-4 d-flex align-center">
                              <div class="text-caption font-weight-bold black--text my-2 me-3">Fase da cotação</div>
                              <app-badge rounded :color="getStatusColor((cotacao && cotacao.status_nome) || null)">
                                <span :class="getStatusIcon((cotacao && cotacao.status_nome) || null)" class="mr-1 text-sm-body-1"></span>
                                {{ (cotacao && cotacao.status_nome) || null }}
                              </app-badge>
                            </div>

                            <div class="mb-4 d-flex align-center">
                              <div class="text-caption font-weight-bold black--text my-2 me-3">Situação da decisão</div>
                              <app-badge rounded :color="getDecisaoColor((cotacao && cotacao.decisao_nome) || null)">
                                {{ (cotacao && cotacao.decisao_nome) || null }}
                              </app-badge>
                            </div>

                            <div class="d-flex align-center">
                              <div class="text-caption font-weight-bold black--text my-2 me-3">Situação dos pedidos</div>
                              <app-badge rounded :color="getSituacaoColor((cotacao && cotacao.situacao_pedidos_nome) || null)">
                                {{ (cotacao && cotacao.situacao_pedidos_nome) || null }}
                              </app-badge>
                            </div>
                          </v-col>

                          <!-- Column 2: Itens -->
                          <v-col cols="12" md="3" v-if="resumo.metricas && resumo.metricas.itens_nesta_cotacao">
                            <div class="text-caption font-weight-bold black--text">Itens nesta cotação</div>
                            <div class="text-h6 font-weight-bold black--text my-2">{{ resumo.metricas.itens_nesta_cotacao.total }}</div>

                            <div class="mb-2 d-flex align-center grey--text text--darken-1">
                              <v-icon small color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                              <span class="text-cards">{{ resumo.metricas.itens_nesta_cotacao.itens_com_proposta }} itens com proposta</span>
                            </div>
                            <div class="mb-2 d-flex align-center grey--text text--darken-1">
                              <v-icon small color="orange darken-1" class="mr-2">mdi-alert-circle-outline</v-icon>
                              <span class="text-cards">{{ resumo.metricas.itens_nesta_cotacao.itens_sem_proposta }} itens sem proposta</span>
                            </div>
                            <div class="d-flex align-center grey--text text--darken-1">
                              <v-icon small color="orange darken-1" class="mr-2">mdi-alert-circle-outline</v-icon>
                              <span class="text-cards">{{ resumo.metricas.itens_nesta_cotacao.itens_sem_ganhador }} itens sem ganhador</span>
                            </div>
                          </v-col>

                          <!-- Column 3: Fornecedores -->
                          <v-col cols="12" md="4" v-if="resumo.metricas && resumo.metricas.fornecedores">
                            <div class="text-caption font-weight-bold black--text">Fornecedores</div>
                            <div class="text-h6 font-weight-bold black--text my-2">{{ resumo.metricas.fornecedores.total }}</div>
                            <div class="d-flex align-center grey--text text--darken-1">
                              <v-icon small color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                              <span>{{ resumo.metricas.fornecedores.responderam }} responderam</span>
                              <v-tooltip top max-width="320">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="grey darken-1"
                                    class="ml-1 cursor-help"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div class="py-1">
                                  <template v-if="fornecedoresResponderamTooltip.empty">
                                    <span>{{ fornecedoresResponderamTooltip.message }}</span>
                                  </template>
                                  <template v-else>
                                    <div class="font-weight-medium mb-1">{{ fornecedoresResponderamTooltip.title }}</div>
                                    <ul class="ma-0 pl-3" style="list-style: disc;">
                                      <li v-for="(nome, i) in fornecedoresResponderamTooltip.names" :key="i">{{ nome }}</li>
                                    </ul>
                                    <div v-if="fornecedoresResponderamTooltip.restante > 0" class="mt-1 text-caption">
                                      … e mais {{ fornecedoresResponderamTooltip.restante }} fornecedores.
                                    </div>
                                  </template>
                                </div>
                              </v-tooltip>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Próximo Passo Section -->
                  <v-col cols="12" md="4" v-if="resumo.metricas">
                    <v-card outlined height="100%" v-if="cotacao && cotacao.status_nome === 'Rascunho'">
                      <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-1">Próximo passo sugerido</v-card-title>
                      <v-card-text class="d-flex flex-column" style="height: calc(100% - 48px);" >
                        <div class="pa-4 rounded mb-4" style="background-color: #F5F8FA;">
                          <i class="text-body-2 grey--text text--darken-3 font-italic">
                            Cotação em preparação. Finalize e publique a cotação.
                          </i>
                        </div>
                        <div class="text-right">
                          <v-btn color="primary" elevation="1" class="text-capitalize px-6" @click="edit">
                            Editar cotação
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card outlined height="100%" v-else-if="cotacao && cotacao.status_nome === 'Concluída'">
                      <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-1">Próximo passo sugerido</v-card-title>
                      <v-card-text class="d-flex flex-column" style="height: calc(100% - 48px);" >
                        <div class="pa-4 rounded mb-4" style="background-color: #F5F8FA;">
                          <i class="text-body-2 grey--text text--darken-3 font-italic">
                            Todos os itens possuem ganhador. Você pode agora gerar pedidos.
                          </i>
                        </div>
                        <div class="text-right">
                          <v-btn
                            color="primary"
                            elevation="1"
                            class="text-capitalize px-6"
                            :disabled="cotacao && cotacao.situacao_pedidos_nome === 'Todos gerados'"
                            @click="gerarPedidos"
                          >
                            Gerar pedidos
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card outlined height="100%" v-else-if="cotacao && cotacao.status_nome === 'Cancelada'">
                      <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-1">Próximo passo sugerido</v-card-title>
                      <v-card-text class="d-flex flex-column" style="height: calc(100% - 48px);" >
                        <div class="pa-6 rounded mb-8" style="background-color: #F5F8FA;">
                          <i class="text-body-2 grey--text text--darken-3 font-italic">
                            Esta cotação foi cancelada. Nenhuma ação disponível.
                          </i>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card outlined height="100%" v-else>
                      <v-card-title class="subtitle-2 font-weight-bold grey--text text--darken-1">Próximo passo sugerido</v-card-title>
                      <v-card-text class="d-flex flex-column" style="height: calc(100% - 48px);" >
                        <div class="pa-6 rounded mb-8" style="background-color: #F5F8FA;">
                          <i class="text-body-2 grey--text text--darken-3 font-italic">
                            Analise as propostas e selecione ganhadores para {{ resumo.metricas.itens_nesta_cotacao.itens_sem_ganhador || 0 }} itens sem definição.
                          </i>
                        </div>
                        <div class="text-right">
                          <v-btn color="primary" elevation="1" class="text-capitalize px-6" @click="activeTab = 1">
                            Ir para análise de propostas
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Suppliers Table -->
                <v-card outlined class="mt-4" v-if="resumo.resumo_fornecedores && resumo.resumo_fornecedores.length">
                  <v-card-title class="subtitle-2 font-weight-bold px-6 py-4">Resumo fornecedores</v-card-title>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left pl-6">Fornecedor</th>
                          <th class="text-left">CNPJ</th>
                          <th class="text-left">Status de participação</th>
                          <th class="text-right pr-6">Itens com proposta</th>
                        </tr>
                      </thead>
                      <tbody v-if="resumo.resumo_fornecedores.length">
                        <tr v-for="item in resumo.resumo_fornecedores" :key="item.id">
                          <td class="pl-6 py-4 font-weight-medium">{{ item.razao_social }}</td>
                          <td class="grey--text">{{ formatCNPJ(item.cnpj) || 'N/D' }}</td>
                          <td>
                            <app-badge rounded :color="getChipColor(item.status_participacao)">
                              {{ item.status_participacao }}
                            </app-badge>
                          </td>
                          <td class="pr-6">
                            <div class="d-flex align-center justify-end">
                              <span class="mr-3 text-body-2 font-weight-medium">{{ item.percentual_itens_com_proposta }}%</span>
                              <v-progress-linear
                                :value="item.percentual_itens_com_proposta"
                                height="8"
                                rounded
                                :color="getProgressBarColor(item.percentual_itens_com_proposta)"
                                style="width: 100px;"
                              ></v-progress-linear>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>

                <v-card outlined v-else class="mt-4">
                  <v-card-title class="subtitle-2 font-weight-bold px-6 py-4">Resumo fornecedores</v-card-title>
                  <div class="text-center py-10">
                    <div class="d-flex flex-column align-center justify-center grey--text text--lighten-1">
                      <v-icon size="64" color="grey lighten-2">mdi-truck-outline</v-icon>
                      <span class="text-body-2 mt-2 grey--text text--darken-1">Não há fornecedores adicionados.</span>
                    </div>
                  </div>
                </v-card>

              </v-tab-item>

              <v-tab-item key="propostas">
                <DetalhesCotacaoPropostaTab
                  :key="idCotacao"
                  :cotacao-id="idCotacao"
                  :status-cotacao="cotacao && cotacao.status_nome"
                  :termino-recebimento="config && config.termino_periodo_recebimento_proposta"
                  @refresh="fetchDetails"
                />
              </v-tab-item>

              <v-tab-item key="pedidos">
                <!-- Orders Table -->
                <v-card outlined class="mt-4" v-if="cotacao && cotacao.situacao_pedidos_nome === 'Todos gerados' && pedidos.length">
                  <v-card-title class="subtitle-2 font-weight-bold px-6 py-4">Pedidos gerados</v-card-title>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left pl-6">Nº do pedido</th>
                          <th class="text-left">Fornecedor</th>
                          <th class="text-right">Valor total</th>
                          <th class="text-center pr-6">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="order in pedidos" :key="order.idpedido">
                          <td class="pl-6 py-4">{{ order.idpedido }}</td>
                          <td>{{ order.fornecedor }}</td>
                          <td class="text-right">{{ formatarValorMonetario(order.valor_total) }}</td>
                          <td class="text-center pr-6">
                            <v-btn
                              small
                              outlined
                              color="grey darken-1"
                              class="mr-2 text-capitalize"
                              :loading="isLoading"
                              @click="baixarPdfPedido(order.idpedido)"
                            >
                              Baixar PDF
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>

                <v-card outlined class="mt-4" v-else>
                  <v-card-title class="subtitle-2 font-weight-bold px-6 py-4">Pedidos gerados</v-card-title>
                  <div class="text-center py-10">
                    <div class="d-flex flex-column align-center justify-center grey--text text--lighten-1">
                      <v-icon size="64" color="grey lighten-2">mdi-cart-outline</v-icon>
                      <span class="text-body-2 mt-2 grey--text text--darken-1">Não há pedidos gerados ainda.</span>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item key="historico">
                 <DetalhesCotacaoHistoricoTab
                     :key="idCotacao"
                     :id-cotacao="idCotacao"
                 />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal de Prorrogação de Vigência -->
    <ProrrogarVigenciaDialog
      :visible="extendDeadlineDialog"
      :id-cotacao="idCotacao"
      :current-deadline="config && config.termino_periodo_recebimento_proposta"
      :handleClose="closeExtendDeadlineDialog"
      :onSuccess="fetchDetails"
    />
  </div>
</template>

<script setup>
import logo from "@/assets/logo_header.png";
import AppBadge from "@/components/utils/ui_v4/feedback/AppBadge.vue";
import DetalhesCotacaoHistoricoTab from "@/components/webcotacao/components/DetalhesCotacaoHistoricoTab.vue";
import DetalhesCotacaoPropostaTab from "@/components/webcotacao/components/DetalhesCotacaoPropostaTab.vue";
import ProrrogarVigenciaDialog from "@/components/webcotacao/components/ProrrogarVigenciaDialog.vue";
import useDetalhesCotacaoDialog from "@/components/webcotacao/composables/useDetalhesCotacaoDialog";
import { formatarValorMonetario } from "@/helpers";
import { formatCNPJ } from "@/components/webcotacao/utils/stringUtils";


const props = defineProps({
  visible: { type: Boolean },
  idCotacao: { type: Number },
  handleClose: { type: Function },
  handleEdit: { type: Function },
});

const {
  isLoading,
  close,
  edit,
  repeatQuotation,
  endQuotationNow,
  extendDeadlineDialog,
  openExtendDeadlineDialog,
  closeExtendDeadlineDialog,
  fetchDetails,
  dialogVisible,
  tabs,
  steps,
  fornecedoresResponderamTooltip,
  orders,
  activeTab,
  getStatusColor,
  getStatusIcon,
  getChipColor,
  getDecisaoColor,
  getSituacaoColor,
  getProgressBarColor,
  cotacao,
  resumo,
  responsavel,
  config,
  seguidores,
  empresa,
  pedidos,
  prazoInfo,
  baixarEvidencias,
  gerarPedidos,
  baixarPdfPedido
} = useDetalhesCotacaoDialog(props);

</script>

<style scoped>
#content-body {
  padding: 12px;
  background: #ffffff;
}
.text-cards {
  font-size: small;
}

.header-info {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
</style>
